<div>
  <button style="float: right;" title="{{'labels.close' | translate}}" (click)="closeDialog()" mat-icon-button color="warn" aria-label="icon-button save">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
    <mat-form-field style="width: 100%;">
        <mat-label>{{'labels.notes' | translate}}:</mat-label>
        <textarea  matInput rows="5" [(ngModel)]="data.commento"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="data.commento" style="text-align: center">Ok</button>
</div>


<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
